import { gql, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useQueryParams from '../../../../hooks/useQueryParams';

function useFindProduct(
  variables,
  changeFeaturedFabrics,
  setChangeFeaturedFabrics,
  setFeaturedFabrics
) {
  const history = useHistory();
  const user = useSelector(state => state.Auth.user);
  const queryParams = useQueryParams();
  const collectionId = queryParams.get('collection_id');
  const emailForNewsLetter = localStorage.getItem('emailForNewsLetter');

  const { data, error, loading, client } = useQuery(FIND_PRODUCT, {
    variables: {
      ...variables,
      user_email: user.email
        ? user.email
        : emailForNewsLetter
        ? emailForNewsLetter
        : ''
    },
    skip: Object.values(variables).every(x => x === null || x === ''),
    onCompleted() {
      if (data) {
        if (data.findProduct.slug) {
          const url = collectionId
            ? `/products/${data.findProduct.slug}?collection_id=${collectionId}`
            : `/products/${data.findProduct.slug}`;

          history.push(url);

          if (changeFeaturedFabrics) {
            handleFeaturedFabrics(data.findProduct.slug);
            //run query
          }
        }
      }
    },
    fetchPolicy: 'cache-and-network',
    onError(error) {
      // if (!anyError) {
      //   setAnyError(true);
      //   scroll.scrollToTop();
      // }
    }
  });

  const handleFeaturedFabrics = async slug => {
    const result = await client.query({
      query: GET_FEATURED_PRODUCT_FABRICS,
      variables: {
        slug: slug,
        collection_id: collectionId ? collectionId : ''
      }
    });

    setFeaturedFabrics(result.data);
    setChangeFeaturedFabrics(false);
  };


  return { loading, error, data };
}

export default useFindProduct;

export const GET_FEATURED_PRODUCT_FABRICS = gql`
  query getFeaturedProductFabrics($slug: String!, $collection_id: ID) {
    getFeaturedProductFabrics(slug: $slug, collection_id: $collection_id) {
      id
      treatment {
        id
        name
      }
      is_available_on_pdp
      name
      description
      image
      material {
        id
        name
        description
        composition
        durability
      }
      collaborator {
        id
        name
      }
      pattern {
        id
        name
      }
    }
  }
`;

const FIND_PRODUCT = gql`
  query findProduct(
    $fabric_id: Int
    $size_id: Int
    $firmness_id: Int
    $leg_id: Int
    $caster_leg_id: Int
    $frame_id: Int!
    $orientation: Int
    $is_assembled: Int
    $wallpaper_type: String
    $supplier_quantity: Int
    $user_email: String
    $pillow_insert_id: Int
    $lining_id: Int
    $construction_type_id: Int
  ) {
    findProduct(
      fabric_id: $fabric_id
      size_id: $size_id
      firmness_id: $firmness_id
      leg_id: $leg_id
      caster_leg_id: $caster_leg_id
      frame_id: $frame_id
      orientation: $orientation
      is_assembled: $is_assembled
      wallpaper_type: $wallpaper_type
      supplier_quantity: $supplier_quantity
      user_email: $user_email
      pillow_insert_id: $pillow_insert_id
      lining_id: $lining_id
      construction_type_id: $construction_type_id
    ) {
      id
      slug
      sku
      name
      price
      supplier_quantity
      minimum_advertised_price
      badge_treatment {
        id
        name
      }
      traditional_retail_price
      full_price
      lead_time
      shipping_window
      warranty
      care
      is_purchasable
      is_assembled
      allow_individual_purchases
      availableWallpaperTypes
      uses_inventory
      current_inventory
      inventory_threshold
      bestReview {
        id
        user {
          id
          first_name
          last_name
        }
        rating
        title
        message
      }
      supplier {
        id
      }
      bundle_products {
        id
        quantity
        product {
          id
          slug
          sku
          name
          price
          frame {
            id
            name
            size {
              id
              is_available_on_pdp
              name
            }
            firmness {
              id
              name
            }
            subcategories {
              id
              name
              category {
                id
                name
              }
            }
            primarySubcategory {
              id
              category_id
              name
            }
          }
          fabric {
            id
            name
            is_available_on_pdp
            collaborator {
              id
              name
            }
          }
          images {
            id
            name
            path
          }
        }
      }
      fabric {
        id
        treatment {
          id
          name
        }
        is_available_on_pdp
        name
        image
        image_width
        image_height
        description
        colors {
          id
          name
        }
        material {
          id
          name
          care
          description
          durability
          composition
          image
        }
        collaborator {
          id
          name
        }
        pattern {
          id
          name
        }
        is_available
        swatch {
          id
          price
          slug
          is_purchasable
          is_swatch
          name
        }

        linkedFabric {
          id
          is_available_on_pdp
          name
        }
      }
      images {
        id
        name
        path
        width
        height
      }
      availableSizes {
        id
        is_available_on_pdp
        name
      }
      availableFirmnesses {
        id
        name
      }
      leg {
        id
        name
      }
      casterLeg {
        id
        name
      }
      pillowInsert {
        id
        name
      }
      lining {
        id
        name
      }
      constructionType {
        id
        name
      }
      frame {
        id
        name
        slug
        oversize_fee
        remote_locations_shipping_fee
        description
        frame_materials
        type {
          id
          name
        }
        is_final_sale
        has_assembly_options
        has_set_of_two
        weight
        weight_limit
        assembly_instructions
        country_of_origin
        compliance
        ship_method
        box_spring
        box_dimensions
        wallpaper_type
        orientation
        dimensions
        dimensions_image
        dimensions_image_width
        dimensions_image_height
        additional_details
        pillowscaping_icon
        primarySubcategory {
          id
          category_id
          name
        }
        pillowscapingFrames {
          id
          slug
        }
        shippingServices {
          id
          name
          price
        }
        subcategories {
          id
          name
          avg_rating
          total_reviews
          category {
            id
            name
            slug
          }
        }
        lifestyles {
          id
          image
          width
          height
        }
        size {
          id
          is_available_on_pdp
          name
        }
        firmness {
          id
          name
        }
        legs {
          id
          name
          image
        }
        casterLegs {
          id
          name
          image
        }
        linings {
          id
          name
        }
        constructionTypes {
          id
          name
          image
        }
      }
    }
  }
`;
